import { useEffect, useState } from 'react';

// 2026-09-26 (dono): UMA guerra por dia, canal 21, as 21h (hora local).
// O disparo e' o cron do 162 (/etc/crontab -> /home/f403_war_start.sh).
export const WAR_HOURS = [21];

export const NATION_NAME: Record<number, string> = { 1: 'Capella', 2: 'Procyon' };

export function nextWarDate(now = new Date()): Date {
  for (const h of WAR_HOURS) {
    const candidate = new Date(now);
    candidate.setHours(h, 0, 0, 0);
    if (candidate > now) return candidate;
  }
  // Nenhuma hora restante hoje -> primeira hora de amanha
  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(WAR_HOURS[0], 0, 0, 0);
  return tomorrow;
}

/** Inicio do intervalo atual (ultima hora de guerra que ja passou). */
export function prevWarDate(now = new Date()): Date {
  let best: Date | null = null;
  for (const h of WAR_HOURS) {
    const c = new Date(now);
    c.setHours(h, 0, 0, 0);
    if (c <= now) best = c;
  }
  if (best) return best;
  const y = new Date(now);
  y.setDate(y.getDate() - 1);
  y.setHours(WAR_HOURS[WAR_HOURS.length - 1], 0, 0, 0);
  return y;
}

/** "54 minutos" / "2h" / "2h 5min" — texto longo da home. */
export function fmtWarDuration(target: Date): string {
  const diffMs = target.getTime() - Date.now();
  if (diffMs <= 0) return 'agora';
  const totalMin = Math.max(1, Math.ceil(diffMs / 60000));
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  if (h === 0) return `${m} ${m === 1 ? 'minuto' : 'minutos'}`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}min`;
}

/** "54m" / "2h" / "2h5m" — texto curto do card do painel. */
export function fmtWarShort(target: Date): string {
  const totalMin = Math.max(1, Math.ceil((target.getTime() - Date.now()) / 60000));
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h${m}m`;
}

/** Contagem pra proxima guerra, atualizada a cada 30s. */
export function useNextWar() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(t);
  }, []);
  const next = nextWarDate(now);
  const prev = prevWarDate(now);
  const span = next.getTime() - prev.getTime();
  // fracao do intervalo entre a ultima e a proxima guerra (barra do card)
  const progress = span > 0 ? Math.min(1, Math.max(0, (now.getTime() - prev.getTime()) / span)) : 0;
  return {
    next,
    long: fmtWarDuration(next),
    short: fmtWarShort(next),
    hour: `${String(next.getHours()).padStart(2, '0')}:00`,
    progress,
  };
}

export function formatScore(n: number) {
  if (n >= 1000000) return `${(n / 1000000).toFixed(2)}M`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}K`;
  return String(n);
}
